import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Jobs = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({
    jobType: 'ALL',
  });
  const [query, setQuery] = useState('marketing jobs in chicago');  // Default query

  const fetchJobs = async () => {
    setLoading(true);  // Set loading state to true when fetching
    const options = {
      method: 'GET',
      url: 'https://jsearch.p.rapidapi.com/search',
      params: {
        query: query,  // Use dynamic query
        page: page.toString(),
        num_pages: '1',
        country: 'us',
        date_posted: 'week',
        employment_types: 'FULLTIME'
      },
      headers: {
        'x-rapidapi-key': 'fb0e9e50aamshc485fdeb648badap1c04d4jsnaef19dc42bb0',
        'x-rapidapi-host': 'jsearch.p.rapidapi.com',
      },
    };

    try {
      const response = await axios.request(options);
      if (response.data && response.data.data) {
        setJobs(response.data.data);
        setLoading(false);  // Set loading state to false after data is fetched
      } else {
        setError('No jobs found.');
        setLoading(false);
      }
    } catch (error) {
      console.error('Error fetching jobs:', error);
      setError('Failed to load jobs.');
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, [page, filters, query]);  // Fetch jobs whenever page, filters, or query changes

  const handleJobTypeChange = (event) => {
    setFilters({ ...filters, jobType: event.target.value });
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleQueryChange = (event) => {
    setQuery(event.target.value);  // Update the query as user types
  };

  return (
    <>
      <div className="container my-4">
        <div className="text-center">
          <h1 className="pt-4 text-instagram">
            <strong>JOBS</strong>
          </h1>

          {/* Search Query Input */}
          <div className="mb-3">
            <label htmlFor="jobQuery" className="form-label">
              Search for Jobs:
            </label>
            <input
              type="text"
              className="form-control"
              id="jobQuery"
              value={query}
              onChange={handleQueryChange}  // Update query on change
              placeholder="Enter job title or location"
            />
          </div>

          {/* Job Type Filter */}
          
        </div>

        {/* Loading/Error */}
        {loading ? (
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : error ? (
          <div className="alert alert-danger text-center" role="alert">
            {error}
          </div>
        ) : (
          <div>
            {/* Job Listings */}
            {jobs.length > 0 ? (
              jobs.map((job, index) => (
                <div key={index} className="card mb-3">
                  <div className="card-body">
                    <h5 className="card-title">{job.job_title}</h5>
                    <p className="card-text"><strong>Company:</strong> {job.employer_name}</p>
                    <p className="card-text"><strong>Location:</strong> {job.job_location}</p>
                    <a href={job.job_apply_link} target="_blank" rel="noopener noreferrer" className="text-white btn btn-primary">
                      Apply Here
                    </a>
                  </div>
                </div>
              ))
            ) : (
              <p>No jobs found.</p>
            )}

            {/* Pagination */}
            <div className="d-flex justify-content-between">
              <button
                className="btn btn-secondary"
                onClick={() => handlePageChange(page - 1)}
                disabled={page <= 1}
              >
                Previous
              </button>
              <span>Page {page}</span>
              <button
                className="btn btn-secondary"
                onClick={() => handlePageChange(page + 1)}
                disabled={jobs.length === 0}
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Jobs;
